// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2506":"3292d8db4285cf89","3415":"09c14a32bd154233","5211":"ab5ee00cbeac3062","6840":"10965b6eca7a0688","9531":"424bdb3281798b4e","9617":"680a83c96696fe5c"}[chunkId] + ".js";
};